(function () {
  'use strict';

  /* Mobile menu */
  var header = document.querySelector('.site-header');
  var toggle = document.querySelector('.menu-toggle');
  if (toggle && header) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Toast */
  var toast = document.getElementById('CartToast');
  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  function updateBagCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var val = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* AJAX add to cart */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || '...'; }

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || 'Error');
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateBagCount(cart.item_count);
          if (window.__openCartDrawer) { window.__openCartDrawer(); } else { showToast(form.getAttribute('data-added-text') || 'Added to bag'); }
        })
        .catch(function (err) { showToast(err.message); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  });

  /* Product gallery thumbs */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main img');
    gallery.querySelectorAll('.product-gallery__thumbs button').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('.product-gallery__thumbs button').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.getAttribute('data-src');
          if (thumb.getAttribute('data-srcset')) {
            main.setAttribute('srcset', thumb.getAttribute('data-srcset'));
          }
        }
      });
    });
  });

  /* Variant selection -> update price + hidden id */
  document.querySelectorAll('[data-variant-json]').forEach(function (script) {
    var form = document.querySelector('form[data-product-form]');
    if (!form) return;
    var variants = JSON.parse(script.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var money = document.querySelector('[data-money-format]');
    var fmt = money ? money.getAttribute('data-money-format') : '{{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    }

    function currentOptions() {
      var opts = [];
      document.querySelectorAll('.variant-pills').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    document.querySelectorAll('.variant-pills input').forEach(function (input) {
      input.addEventListener('change', function () {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (match && idInput) {
          idInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          var submit = form.querySelector('[type="submit"]');
          if (submit) {
            submit.disabled = !match.available;
            submit.textContent = match.available
              ? submit.getAttribute('data-default-text')
              : submit.getAttribute('data-soldout-text');
          }
        }
      });
    });
  });

  /* Cart page quantity change */
  document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }
})();

/* ============ byanchor additions ============ */
(function () {
  'use strict';

  /* Header: solid on scroll (transparent variant on homepage) */
  var hdr = document.querySelector('[data-header]');
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Cart drawer */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  if (drawer && overlay) {
    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var emptyEl = drawer.querySelector('[data-drawer-empty]');
    var footEl = drawer.querySelector('[data-drawer-foot]');
    var subEl = drawer.querySelector('[data-drawer-subtotal]');
    var moneyFormat = itemsEl.getAttribute('data-money-format') || '£{{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    }

    function setCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      document.querySelectorAll('[data-bag-dot]').forEach(function (el) { el.classList.toggle('has-items', count > 0); });
    }

    function render(cart) {
      setCounts(cart.item_count);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        footEl.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      footEl.hidden = false;
      subEl.textContent = money(cart.items_subtotal_price);
      itemsEl.innerHTML = cart.items.map(function (it) {
        return '<div class="drawer-line" data-key="' + it.key + '">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="" loading="lazy">' : '<span class="drawer-line__noimg"></span>') +
          '<div class="drawer-line__info">' +
            '<span class="drawer-line__title">' + it.product_title + '</span>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="drawer-line__variant">' + it.variant_title + '</span>' : '') +
            '<div class="drawer-line__row">' +
              '<span class="drawer-qty"><button type="button" data-line-change="-1" aria-label="-">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line-change="1" aria-label="+">+</button></span>' +
              '<span class="drawer-line__price">' + money(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="drawer-line__remove" data-line-remove aria-label="Remove">&times;</button>' +
        '</div>';
      }).join('');
    }

    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
    }

    function open() {
      refresh().then(function () {
        drawer.classList.add('is-open');
        overlay.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('drawer-lock');
      });
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('drawer-lock');
    }
    window.__openCartDrawer = open;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-drawer-close]') || e.target === overlay) { close(); return; }

      var chg = e.target.closest('[data-line-change]');
      var rem = e.target.closest('[data-line-remove]');
      if (chg || rem) {
        var line = e.target.closest('.drawer-line');
        var key = line.getAttribute('data-key');
        var qty = 0;
        if (chg) {
          var current = parseInt(line.querySelector('.drawer-qty span').textContent, 10) || 0;
          qty = Math.max(0, current + parseInt(chg.getAttribute('data-line-change'), 10));
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); }).then(render);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Collection tabs (All / Featured) */
  document.querySelectorAll('[data-collection-tabs]').forEach(function (wrap) {
    wrap.querySelectorAll('[data-tab-target]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');
        wrap.querySelectorAll('[data-tab-target]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        wrap.querySelectorAll('[data-tab-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-tab-panel') !== target;
        });
      });
    });
  });

  /* Cookie notice */
  var notice = document.querySelector('[data-cookie-notice]');
  if (notice) {
    try {
      if (!localStorage.getItem('cookie-notice-dismissed')) notice.hidden = false;
    } catch (e) { notice.hidden = false; }
    var dismiss = notice.querySelector('[data-cookie-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function () {
      notice.hidden = true;
      try { localStorage.setItem('cookie-notice-dismissed', '1'); } catch (e) {}
    });
  }
})();
/* Product subnav scroll-spy */
(function () {
  var nav = document.querySelector('.product-subnav');
  if (!nav) return;
  var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
  var targets = links.map(function (a) {
    return document.querySelector(a.getAttribute('href'));
  });
  function update() {
    var pos = window.scrollY + window.innerHeight * 0.35;
    var idx = 0;
    targets.forEach(function (t, i) {
      if (t && t.offsetTop <= pos) idx = i;
    });
    links.forEach(function (a, i) {
      a.classList.toggle('is-active', i === idx);
    });
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
/* Product subnav: docks above footer instead of overlapping it */
(function () {
  var nav = document.querySelector('.product-subnav');
  var footer = document.querySelector('.site-footer');
  if (!nav || !footer) return;

  function update() {
    var footerTop = footer.getBoundingClientRect().top;
    var navH = nav.offsetHeight;
    if (footerTop <= window.innerHeight) {
      // footer is visible: dock subnav right above it
      var pageTop = window.scrollY + footerTop - navH;
      nav.style.setProperty('--dock-top', pageTop + 'px');
      nav.classList.add('is-docked');
    } else {
      nav.classList.remove('is-docked');
    }
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();